import EarlyBirdCollege from './EarlyBirdCollege';
import EarlyBirdCollegeEdit from './EarlyBirdCollegeEdit';

export {
  EarlyBirdCollege,
  EarlyBirdCollegeEdit,
};



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCollege/index.js